export { default } from './WixDesignSystemIconThemeProvider';
export { useIcons } from './hooks/useIcons';
export * from './WixDesignSystemIconThemeProvider.types';
